"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Vendors
 */
require("picturefill");
require("lazysizes");
require("./vendor/ls.object-fit");
const micromodal_1 = require("micromodal");
/**
 * Import Functions
 */
require("./functions/formValidation");
// import './functions/cookieController';
// import './functions/cookieControllerSettings'
const global_1 = require("./functions/global");
const navMain_1 = require("./functions/navMain");
const mobileNav_1 = require("./functions/mobileNav");
const sectorSlider_1 = require("./functions/sectorSlider");
const sliders_1 = require("./functions/sliders");
const accordion_1 = require("./functions/accordion");
const stickyHeader_1 = require("./functions/stickyHeader");
const countUp_js_1 = require("./functions/countUp.js");
const ajaxFilter_1 = require("./functions/ajaxFilter");
const forms_js_1 = require("./functions/forms.js");
const districtMap_js_1 = require("./functions/districtMap.js");
const coworking_listing_1 = require("./functions/coworking-listing");
/**
 * Call Functions
 */
(0, global_1.global)();
(0, global_1.accessibility)();
(0, navMain_1.navMain)();
(0, stickyHeader_1.stickyHeader)();
(0, mobileNav_1.mobileNav)();
(0, sectorSlider_1.sectorSlider)();
(0, sliders_1.sliders)();
(0, accordion_1.accordion)();
(0, ajaxFilter_1.ajaxFilter)();
(0, countUp_js_1.countUp)();
(0, districtMap_js_1.districtMap)();
(0, forms_js_1.forms)();
(0, coworking_listing_1.default)();
micromodal_1.default.init({
    onClose: modal => {
        if (modal.dataset.modalType === 'video') {
            const container = modal.querySelector('.modal__container');
            const figure = container.querySelector('figure');
            figure.remove();
            container.append(figure);
        }
    }
});
